import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { giftData } from "../../../mocks/homeData";

export default function GiftSection() {
  return (
    <section className="py-20 md:py-28 bg-airdoa-navy text-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <ScrollReveal direction="up">
            <p className="text-xs font-medium tracking-ultra text-airdoa-gold uppercase mb-3">
              {giftData.label}
            </p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-semibold leading-tight">
              {giftData.title}
            </h2>
            <p className="mt-6 text-base text-white/70 leading-[1.9] max-w-2xl mx-auto">
              {giftData.description}
            </p>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={150}>
            <div className="mt-10 flex flex-wrap justify-center gap-3">
              {giftData.features.map((f) => (
                <span
                  key={f}
                  className="px-4 py-2 text-xs text-white/80 border border-white/20 rounded-full"
                >
                  {f}
                </span>
              ))}
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={250}>
            <div className="mt-12">
              <Link to={giftData.cta.href} className="btn-primary">
                {giftData.cta.label}
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}